module.exports = __webpack_public_path__ + "static/media/china.6b92cb7d.svg";